import { attendeeFetchData } from "./index";


const ticketAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/addons`),
};

export default ticketAPI;
